export default Object.freeze({
  year: 1,
  month: 2,
});
